import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import I18n from 'I18n';
import { useAvatar } from '../avatarQueries';
import { MAX_AVATAR_FILE_SIZE_MB } from '../../../consts';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import styled from '../../../components/Theme';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AvatarPreview from './AvatarViewer';
import { useUserByAuth } from '../../users/userQueries';
import UIFlex from 'UIComponents/layout/UIFlex';
import AvatarUploadModal from './AvatarUploadModal';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
const RemoveButton = styled(UIButton).withConfig({
  displayName: "AvatarUpload__RemoveButton",
  componentId: "sc-1rv8esp-0"
})(["font-weight:bold;padding:0 !important;"]);
const Spinner = styled(UILoadingSpinner).withConfig({
  displayName: "AvatarUpload__Spinner",
  componentId: "sc-1rv8esp-1"
})(["position:absolute;"]);
const AvatarSectionWrapper = styled(UIFlex).withConfig({
  displayName: "AvatarUpload__AvatarSectionWrapper",
  componentId: "sc-1rv8esp-2"
})(["display:inline-flex;width:auto;"]);
const AvatarInnerSectionWrapper = styled(UIFlex).withConfig({
  displayName: "AvatarUpload__AvatarInnerSectionWrapper",
  componentId: "sc-1rv8esp-3"
})(["flex:0 0 100%;transition:opacity 0.4s ease;pointer-events:", ";opacity:", ";"], props => props.$disable ? 'none' : 'auto', props => props.$disable ? '0.2' : '1');

const AvatarUpload = ({
  title
}) => {
  const {
    deleteAvatar,
    uploadAvatar,
    avatarUploadLoading,
    avatarDeleteLoading
  } = useAvatar();
  const {
    user
  } = useUserByAuth();
  const [isAvatarModalVisible, setAvatarModalVisible] = useState(false);
  const showAvatarModal = useCallback(() => {
    setAvatarModalVisible(true);
  }, []);
  const hideAvatarModal = useCallback(() => {
    setAvatarModalVisible(false);
  }, []);
  const handleRemoveAvatar = useCallback(() => {
    deleteAvatar().then(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('connectDotCom.avatarUpload.removeSuccess'),
        type: 'success'
      });
    }).catch(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('connectDotCom.avatarUpload.removeError'),
        type: 'success'
      });
    });
  }, [deleteAvatar]);
  const handleUploadAvatar = useCallback(blob => {
    uploadAvatar({
      variables: {
        blob
      }
    }).then(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('connectDotCom.avatarUpload.uploadSuccess'),
        type: 'success'
      });
    }).catch(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('connectDotCom.avatarUpload.uploadError'),
        type: 'danger'
      });
    });
  }, [uploadAvatar]);
  const isLoading = avatarUploadLoading || avatarDeleteLoading;
  if (!user) return null;
  return /*#__PURE__*/_jsxs(AvatarSectionWrapper, {
    align: "center",
    justify: "center",
    children: [isAvatarModalVisible && /*#__PURE__*/_jsx(AvatarUploadModal, {
      onHideModal: hideAvatarModal,
      onUploadAvatar: handleUploadAvatar
    }), /*#__PURE__*/_jsxs(AvatarInnerSectionWrapper, {
      $disable: isLoading,
      align: "center",
      children: [/*#__PURE__*/_jsx(AvatarPreview, {
        avatarHash: user.avatarHash,
        lastUpdated: user.avatarLastUpdated
      }), /*#__PURE__*/_jsxs("div", {
        className: "p-left-8 p-right-6",
        children: [title, /*#__PURE__*/_jsx("p", {
          className: "m-bottom-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "connectDotCom.avatarUpload.maxAvatarSize",
            options: {
              maxSize: MAX_AVATAR_FILE_SIZE_MB
            }
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: showAvatarModal,
          size: "small",
          children: I18n.text('connectDotCom.avatarUpload.upload')
        }), /*#__PURE__*/_jsx(RemoveButton, {
          use: "transparent",
          onClick: handleRemoveAvatar,
          children: I18n.text('connectDotCom.avatarUpload.clear')
        })]
      })]
    }), isLoading && /*#__PURE__*/_jsx(Spinner, {
      size: "medium"
    })]
  });
};

export default AvatarUpload;